import { FrameRepository, FrameService } from '@aipb/frame/data-access';
import { FrameComponent } from '@aipb/frame/feature-frame';
import { CONFIG_FRAME, CONFIG_PROJECT } from '@aipb/util/di';
import { getTranslationLang } from '@aipb/util/translation';
import { OverlayModule } from '@angular/cdk/overlay';
import { Component, inject, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { ActivatedRoute, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { getBrowserLang, TranslocoService } from '@jsverse/transloco';
import { filter, take } from 'rxjs/operators';
import { SetupHandlerManager } from './setup-handlers/setup-handler-manager';

@Component({
  imports: [FrameComponent, RouterOutlet, OverlayModule],
  selector: 'aipb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  initHandlerManager = inject(SetupHandlerManager);
  transloco = inject(TranslocoService);
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  frame = inject(FrameService);
  frameRepository = inject(FrameRepository);
  matIconRegistry = inject(MatIconRegistry);
  private project = inject(CONFIG_PROJECT);
  private frameConfig = inject(CONFIG_FRAME);

  constructor() {
    this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    this.activatedRoute.queryParams.pipe(take(2)).subscribe((params) => {
      let lang = params['lang'];

      if (!lang) {
        lang = getTranslationLang(this.project);
      }

      if (!lang) {
        lang = getBrowserLang();
      }

      // @ts-expect-error foo
      if (!lang || !this.frameConfig.languages.some((l) => l.name === lang)) {
        lang = this.frameConfig.defaultLanguage;
      }

      this.transloco.setActiveLang(lang);
    });

    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((data: NavigationStart) => {
      const currentFrameApp = this.frameRepository.activeApp;

      const app = data.url.split('/')[1];

      if (currentFrameApp !== app) {
        this.frame.updateAppHistory(currentFrameApp, this.router.url);
      }
    });
  }

  ngOnInit() {
    this.initHandlerManager.init();
  }
}
